var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 102,
    viewBox: "0 0 187 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark Mode - Empty State Illustrations Style 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.1325 76.4542C68.0632 76.4542 84.2202 60.4123 84.2202 40.6236C84.2202 20.8349 68.0632 4.79297 48.1325 4.79297C28.2019 4.79297 12.0449 20.8349 12.0449 40.6236C12.0449 60.4123 28.2019 76.4542 48.1325 76.4542Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M180.016 79.9442H8.7168L35.3841 44.3927L46.8197 29.316L56.8024 40.0651L58.7239 42.1126L80.189 12.6105L89.375 0L96.5456 10.3769L120.963 45.6957L130.805 34.5277L135.82 28.8041L140.085 33.8762L180.016 79.9442Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.8197 29.3164L46.351 79.9446H8.7168L35.3841 44.3932L46.8197 29.3164Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M89.3757 0L87.829 74.6394L58.7246 42.1126L89.3757 0Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M136.712 72.639L120.965 45.6963L135.822 28.8047L136.712 72.639Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1.5 79.9434H46.3518H180.017H185.5",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M98.2344 87.4824H110.139",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M131.041 87.4824H142.945",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M123.775 87.4824H126.306",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M44.7109 87.4824H87.3599",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.7148 87.4824H32.1046",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M163.707 87.4824H178.704",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M3.98438 87.4824H18.56",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.6074 93.7637H62.7088",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M90.5469 93.7637H123.776",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M140.883 93.7637H174.112",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M76.6738 93.7637H83.9382",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M113.512 100H153.724",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M71.707 100H98.2338",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M54.834 100H62.7076",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M25.4492 100H42.8369",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M64.0666 67.8924C64.0666 70.824 61.6763 72.1269 58.7706 72.1269C55.8648 72.1269 53.4746 70.824 53.4746 67.8924C53.4746 64.9608 58.7706 46.8594 58.7706 46.8594C58.7706 46.8594 64.0666 65.0073 64.0666 67.8924Z",
    fill: "#B5BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M58.7246 62.7734V79.3858",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M58.7246 65.6592L60.6462 63.9375",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M58.7241 69.6148L55.959 66.3574",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M111.684 66.5898C111.684 69.8472 109.012 71.2897 105.778 71.2897C102.498 71.2897 99.873 69.8472 99.873 66.5898C99.873 63.3325 105.778 43.1836 105.778 43.1836C105.778 43.1836 111.684 63.379 111.684 66.5898Z",
    fill: "#B5BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M105.777 60.8672V79.3874",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M105.777 64.1243L107.886 62.1699",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M105.779 68.5433L102.686 64.8672",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M130.899 71.5686C130.899 73.5695 129.259 74.4536 127.29 74.4536C125.275 74.4536 123.682 73.5695 123.682 71.5686C123.682 69.5676 127.29 57.2363 127.29 57.2363C127.29 57.2363 130.899 69.5676 130.899 71.5686Z",
    fill: "#B5BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M127.244 68.0781V79.3857",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M127.244 70.0325L128.556 68.8691",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M127.244 72.7317L125.369 70.498",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M150.256 69.3354C150.256 71.8947 148.194 73.0115 145.616 73.0115C143.039 73.0115 140.977 71.8947 140.977 69.3354C140.977 66.776 145.616 50.9082 145.616 50.9082C145.616 50.9082 150.256 66.776 150.256 69.3354Z",
    fill: "#B5BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M145.617 64.8223V79.3872",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M145.617 67.3348L147.258 65.8457",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M145.617 70.8245L143.18 67.9395",
    stroke: "#7D87A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    opacity: 0.8,
    d: "M59.146 42.3923L51.0848 43.0903L47.3355 46.906L42.8362 46.1149L35.3844 50.7217L33.041 47.697L46.9605 29.3164L59.146 42.3923Z",
    fill: "#A9AFC3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    opacity: 0.6,
    d: "M100.203 15.6352L96.4066 14.7976L92.5167 16.6124L89.3766 15.8213L86.3771 21.1261L81.6904 18.939L76.4413 21.1261L75.5508 19.0786L89.3766 0L100.203 15.6352Z",
    fill: "#A9AFC3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    opacity: 0.6,
    d: "M142.57 36.5757L138.633 39.6469L134.977 37.646L129.822 40.6241L128.369 37.5064L136.008 28.8047L142.57 36.5757Z",
    fill: "#A9AFC3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M43.2578 15.5415C44.0077 15.3554 44.7107 15.3089 45.4605 15.3089C46.1635 15.3089 46.9134 15.3554 47.6164 15.4485C48.3194 15.5415 49.0693 15.7277 49.7723 16.0534C50.4753 16.3791 51.1783 16.8445 51.6001 17.6355L50.8034 17.4494L51.647 16.7979C51.9751 16.6118 52.2563 16.3791 52.5375 16.193C53.1467 15.8207 53.8029 15.495 54.5059 15.2623C55.2089 15.0297 55.9119 14.8435 56.6149 14.7505C57.3648 14.7039 58.0678 14.7039 58.8176 14.8901C58.9582 14.9366 59.0051 15.0762 58.9582 15.1693C58.9114 15.3089 58.8176 15.3554 58.677 15.3089H58.6302C58.0209 15.1693 57.3179 15.2158 56.6618 15.3089C56.0056 15.4019 55.3495 15.6346 54.7402 15.9138C54.1309 16.193 53.5685 16.5187 53.0061 16.891C52.7249 17.0771 52.4437 17.3098 52.2094 17.4959L51.4595 18.1474C51.2252 18.3335 50.944 18.287 50.7565 18.1009L50.7096 18.1474L50.6628 18.0543C50.4753 17.5425 49.9598 17.1237 49.3974 16.8445C48.835 16.5653 48.1788 16.3326 47.4758 16.193C46.8197 16.0534 46.1167 15.9603 45.4137 15.9138C44.7107 15.8673 44.0077 15.8673 43.3984 16.0069H43.3515C43.2109 16.0534 43.1172 15.9603 43.0703 15.8207C43.0703 15.6811 43.1172 15.5415 43.2578 15.5415Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M22.4492 28.2915C23.1991 28.1054 23.9021 28.0589 24.6519 28.0589C25.3549 28.0589 26.1048 28.1054 26.8078 28.1985C27.5108 28.2915 28.2607 28.4777 28.9637 28.8034C29.6667 29.1291 30.3697 29.5945 30.7915 30.3855L29.9948 30.1994L30.8384 29.5479C31.1665 29.3618 31.4477 29.1291 31.7289 28.943C32.3381 28.5707 32.9943 28.245 33.6973 28.0123C34.4003 27.7797 35.1033 27.5935 35.8063 27.5005C36.5562 27.4539 37.2592 27.4539 38.009 27.6401C38.1496 27.6866 38.1965 27.8262 38.1496 27.9193C38.1028 28.0589 38.009 28.1054 37.8684 28.0589H37.8216C37.2123 27.9193 36.5093 27.9658 35.8532 28.0589C35.197 28.1519 34.5409 28.3846 33.9316 28.6638C33.3223 28.943 32.7599 29.2687 32.1975 29.641C31.9163 29.8271 31.6351 30.0598 31.4008 30.2459L30.6509 30.8974C30.4166 31.0835 30.1354 31.037 29.9479 30.8509L29.901 30.8043L29.8542 30.7113C29.6667 30.1994 29.1512 29.7806 28.5888 29.5014C28.0264 29.2222 27.3702 28.9895 26.6672 28.8499C26.0111 28.7103 25.3081 28.6173 24.6051 28.5707C23.9021 28.5242 23.1991 28.5242 22.5898 28.6638H22.5429C22.4023 28.7103 22.3086 28.6173 22.2617 28.4777C22.2617 28.4311 22.3555 28.2915 22.4492 28.2915Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M48.3203 26.4771C49.0702 26.2909 49.7732 26.2444 50.523 26.2444C51.226 26.2444 51.9759 26.2909 52.6789 26.384C53.3819 26.4771 54.1318 26.6632 54.8348 26.9889C55.5378 27.3147 56.2408 27.78 56.6626 28.5711L55.8659 28.3849L56.7095 27.7335C57.0376 27.5473 57.3188 27.3147 57.6 27.1285C58.2092 26.7563 58.8654 26.4305 59.5684 26.1979C60.2714 25.9652 60.9744 25.7791 61.6774 25.686C62.4273 25.6395 63.1303 25.6395 63.8801 25.8256C64.0207 25.8721 64.0676 26.0117 64.0207 26.1048C63.9739 26.2444 63.8801 26.2909 63.7395 26.2444H63.6927C63.0834 26.1048 62.3804 26.1513 61.7243 26.2444C61.0681 26.3375 60.412 26.5701 59.8027 26.8493C59.1934 27.1285 58.631 27.4543 58.0686 27.8265C57.7874 28.0127 57.5062 28.2453 57.2719 28.4315L56.522 29.0829C56.2877 29.2691 56.0065 29.2225 55.819 29.0364L55.7721 28.9899L55.7253 28.8968C55.5378 28.3849 55.0223 27.9661 54.4599 27.6869C53.8975 27.4077 53.2413 27.1751 52.5383 27.0355C51.8822 26.8959 51.1792 26.8028 50.4762 26.7563C49.7732 26.7097 49.0702 26.7097 48.4609 26.8493H48.414C48.2734 26.8959 48.1797 26.8028 48.1328 26.6632C48.1328 26.6167 48.1797 26.4771 48.3203 26.4771Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_44",
    filter: "url(#filter0_d_18341_77151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.683 27.1136C123.683 29.7915 121.502 31.9572 118.781 31.9572C118.734 31.9572 118.335 31.9572 115.404 31.9572C113.363 31.9572 110.103 31.9572 104.896 31.9572H102.41C99.1502 32.0271 96.5469 29.4422 96.5469 26.3218C96.5469 23.1781 99.1737 20.57 102.481 20.733C105.319 11.9306 118.312 13.1648 119.414 22.2699C121.853 22.5727 123.683 24.6219 123.683 27.1136Z",
    fill: "#5C6479"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M110.783 32.0033C115.591 32.0033 119.508 28.1377 119.508 23.364C119.508 18.5902 115.591 14.7246 110.783 14.7246C105.975 14.7246 102.059 18.5902 102.059 23.364C102.059 28.1377 105.952 32.0033 110.783 32.0033Z",
    fill: "url(#paint0_linear_18341_77151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M118.781 31.9568C121.478 31.9568 123.683 29.7911 123.683 27.1132C123.683 24.4352 121.478 22.2695 118.781 22.2695C116.084 22.2695 113.879 24.4352 113.879 27.1132C113.879 29.7911 116.084 31.9568 118.781 31.9568Z",
    fill: "url(#paint1_linear_18341_77151)",
    fillOpacity: 0.37
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_47",
    filter: "url(#filter1_d_18341_77151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1008 35.6348C81.1008 37.6533 79.4567 39.2858 77.406 39.2858C77.3706 39.2858 77.0701 39.2858 74.8602 39.2858C73.3222 39.2858 70.8648 39.2858 66.9401 39.2858H65.0662C62.6088 39.3384 60.6465 37.3901 60.6465 35.038C60.6465 32.6683 62.6265 30.7024 65.1192 30.8253C67.2583 24.1903 77.0524 25.1206 77.8833 31.9838C79.7219 32.212 81.1008 33.7566 81.1008 35.6348Z",
    fill: "#5C6479"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M71.3773 39.3211C75.0014 39.3211 77.9538 36.4073 77.9538 32.809C77.9538 29.2107 75.0014 26.2969 71.3773 26.2969C67.7531 26.2969 64.8008 29.2107 64.8008 32.809C64.8008 36.4073 67.7355 39.3211 71.3773 39.3211Z",
    fill: "url(#paint2_linear_18341_77151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M77.4058 39.2864C79.4389 39.2864 81.1007 37.654 81.1007 35.6354C81.1007 33.6168 79.4389 31.9844 77.4058 31.9844C75.3727 31.9844 73.7109 33.6168 73.7109 35.6354C73.7109 37.654 75.3727 39.2864 77.4058 39.2864Z",
    fill: "url(#paint3_linear_18341_77151)",
    fillOpacity: 0.37
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18341_77151",
    x: 83.5469,
    y: 12.7461,
    width: 53.1367,
    height: 43.2129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18341_77151"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18341_77151",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_18341_77151",
    x: 47.6465,
    y: 24.3125,
    width: 46.4551,
    height: 38.9746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18341_77151"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18341_77151",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18341_77151",
    x1: 104.185,
    y1: 18.3135,
    x2: 107.091,
    y2: 20.5757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80889D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#5C6479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18341_77151",
    x1: 113.346,
    y1: 21.2419,
    x2: 117.651,
    y2: 25.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18341_77151",
    x1: 66.4036,
    y1: 29.0021,
    x2: 68.5941,
    y2: 30.7073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80889D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#5C6479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18341_77151",
    x1: 73.3094,
    y1: 31.2098,
    x2: 76.5539,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationEmptyState);
export default __webpack_public_path__ + "static/media/notification-empty-state.eb7269ab15228787597bc5664574e73c.svg";
export { ForwardRef as ReactComponent };